import React from 'react';
import { connect } from 'react-redux';
import { freeSelected, paidSelected } from '../actions';

const CmpButton = ({ label, type, onClick }) => <button className={`btn btn-${type}`} onClick={onClick}>{label}</button>;

export const ButtonFree = connect(
    state => ({
      label: 'Начать бесплатно',
        type: 'success',
    }),
    dispatch => ({
        onClick: () => dispatch(freeSelected()),
    }),
)(CmpButton);

export const ButtonFreePromo = connect(
    state => ({
      label: 'НАЧАТЬ БЕСПЛАТНО',
        type: 'success',
    }),
    dispatch => ({
        onClick: () => dispatch(freeSelected()),
    }),
)(CmpButton);

export const ButtonPaid = connect(
    state => ({
        label: 'Оплатить участие',
        type: 'warning',
    }),
    dispatch => ({
        onClick: () => dispatch(paidSelected()),
    }),
)(CmpButton);



// WEBPACK FOOTER //
// ./src/marathons/components/ButtonFree.jsx